"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StaffSignupController = /** @class */ (function () {
    function StaffSignupController(UsersModel, FlashService, SchoolsModel, $state) {
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.SchoolsModel = SchoolsModel;
        this.$state = $state;
        this.submitted = false;
        this.schoolCodeValid = false;
        this.schoolInvalidMessage = "";
        this.staff = {};
    }
    StaffSignupController.prototype.formValid = function () {
        return this.schoolCodeValid === true;
    };
    StaffSignupController.prototype.formatCode = function () {
        this.staff.schoolcode = this.staff.schoolcode
            .replace(/[^a-z0-9\s]/gi, "")
            .toUpperCase();
    };
    StaffSignupController.prototype.getSchool = function () {
        var _this = this;
        this.clearInvalidMessage();
        this.FlashService.clearFlash();
        this.schoolCodeValid = false;
        this.SchoolsModel.getSchoolByCode(this.staff.schoolcode).then(function (response) {
            if (response.schoolId) {
                _this.staff.school = response.school;
                _this.school = response.school;
                _this.clearInvalidMessage();
                _this.schoolCodeValid = true;
            }
            else {
                _this.schoolInvalidMessage = response.message;
                _this.schoolCodeValid = false;
            }
        });
    };
    StaffSignupController.prototype.clearInvalidMessage = function () {
        this.schoolInvalidMessage = "";
    };
    StaffSignupController.prototype.submitStaff = function () {
        var _this = this;
        if (this.submitted === true) {
            return;
        }
        this.submitted = true;
        var request = {
            firstname: this.staff.firstname,
            lastname: this.staff.lastname,
            username: this.staff.username,
            password: this.staff.password,
            email: this.staff.email,
            phone: this.staff.phone,
            schoolcode: this.staff.schoolcode,
        };
        this.UsersModel.signupStaff(request)
            .then(function (response) {
            _this.submitted = false;
            _this.$state.go("drivecoach.login");
            _this.FlashService.setMessage({
                type: "success",
                message: response.message || "Account created successfully! Please log in.",
            });
        })
            .catch(function () {
            _this.submitted = false;
        });
    };
    return StaffSignupController;
}());
StaffSignupController.$inject = [
    "UsersModel",
    "FlashService",
    "SchoolsModel",
    "$state",
];
exports.default = StaffSignupController;
